import axios from "axios";
import { baseUrl } from "./urlConfig";

class APIService {


  inputResonse = async (requestData) => {
    try {

      const url = `${baseUrl}/recharge/cbapi/chat`;

      // let config;
      // if (userDetails !== null && userDetails !== undefined) {
      // config = {
      //   params: requestData
      // };
      // }

      const config = {
        headers: { Authorization: `Bearer ${requestData?.token}` },
        params: requestData
      };
      return axios.get(url, config);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };
  regenrate = async (requestData) => {
    try {
      const response = await fetch("https://e016-108-21-87-23.ngrok-free.app/regenerate", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestData),

      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.text();
      return result;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  feedbackApi = async (requestData) => {
    try {
      
      
      const url = `${baseUrl}/recharge/agentFeedback`;

      const response = await fetch(`${baseUrl}/recharge/agentFeedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestData),

      });

      // if (!response.ok) {
      //   throw new Error("Network response was not ok");
      // }

      // const result = await response.text();
      // return result;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  loginForLinkk = async (userDetails) => {
    // localStorage.setItem("linkLoginOnce", true);

    const url = `${baseUrl}/recharge/cbapi/login`;

    const config = userDetails ? {
      bot: "agent-assist",
      user: userDetails,

    } : {};

    const queryString = new URLSearchParams(config).toString();
    const fullUrl = `${url}?${config}`;

    try {
      const response = await fetch(fullUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };
  loginForLink = async (userDetails) => {
    localStorage.setItem("linkLoginOnce", true);

    const url = `${baseUrl}/recharge/cbapi/login`;

    let config;
    if (userDetails !== null && userDetails !== undefined) {
      config = {
        params: {
          bot: "agent-assist",
          user: userDetails,
          gethelpOs: JSON.stringify({
            device: 'isMobile' ? "Mobile" : 'isTablet' ? "Tablet" : "Web",
            // os: osName,
            // osVersion: osVersion,
            // browser: browserName,
          }),
        },
      };
    }
    return axios.get(url, config);
  };

  loginForRefresh = async (data) => {
    const url = `${baseUrl}/recharge/cbapi/updatesession?bot=agent-assist&action=${data}`;

    const bearerToken = sessionStorage.getItem("token");

    const config = {
      headers: { Authorization: `Bearer ${bearerToken}` },
    };

    return axios.post(url, {}, config);
  };
 

}

let apiService = new APIService();
export default apiService;
